import { apiClient } from "./apiClient";

/**
 * `auditLogPdfExport` hits the real GET /management/audit-log/export/pdf, which
 * mirrors the same query params as the real, working GET /management/audit-log
 * (user_id, table, action) and returns raw PDF bytes (Content-Type:
 * application/pdf, Content-Disposition: attachment) -- wired into
 * AuditLogPage.jsx's "Export PDF" button using the same blob-download
 * mechanism as its CSV export.
 *
 * GDPR request queue is real: `gdprRequests` lists requests awaiting a
 * decision (CompliancePage.jsx asks for status=Pending) and
 * `decideGdprRequest` posts an approve/deny decision. Export requests are
 * fulfilled synchronously by the user-facing app (GET /export/all/zip) and
 * essentially never reach this queue in a Pending state -- expect this to
 * mostly show Deletion requests. Approving a Deletion soft-deletes that
 * user's account and force-logs them out server-side, which is why the page
 * requires a confirmation dialog before approving one.
 *
 * `complianceDashboard` remains a GAP -- no single endpoint aggregates RLS
 * coverage, Always Encrypted status, audit retention, and GDPR fulfillment
 * into one posture view yet.
 */
export const complianceApi = {
  auditLogPdfExport: (params) => apiClient.get("/management/audit-log/export/pdf", { params, responseType: "blob" }),

  gdprRequests: (params) => apiClient.get("/management/gdpr/requests", { params }).then((r) => r.data),
  decideGdprRequest: (requestId, payload) =>
    apiClient.post(`/management/gdpr/requests/${requestId}/decision`, payload).then((r) => r.data),

  complianceDashboard: () => apiClient.get("/management/compliance/dashboard").then((r) => r.data),
};
